import React, { useState, useCallback, useEffect } from 'react';
import CategoryManagerView from './CategoryManagerView/CategoryManagerView';
import InfoManagerView from './InfoManagerView/InfoManagerView';
import LoginView from './LoginView/LoginView';
import ProductManagerView from './ProductManagerView/ProductManagerView';
import { Routes, Route } from 'react-router-dom';
import ManagerNavBar from './ManagerCommonView/ManagerNavBar/ManagerNavBar'
import BackgroundImageManagerView from './BackgroundImageManagerView/BackgroundImageManagerView';
import { AuthContext } from '../../share/context/auth-context';

// For send request and handle request error
import useHttpClient from '../../share/hook/http-hook';
import LoginFailureView from './LoginFailureView/LoginFailureView';
import LoginSuccessView from './LoginView/LoginSucessView/LoginSuccessView';

let logoutTimer;

function ManagerView(props) {
    const [token, setToken] = useState(null);
    const [userId, setUserId] = useState(null);
    const [tokenExpirationDate, setTokenExpirationDate] =  useState();

    

    /*
    // header to send request
    const headers = {
        "Content-Type": "application/json",
        "Accept": "application/json"
    };
*/
    const login = useCallback((uid, token, expiration) => {
        setToken(token);
        setUserId(uid);
        setTokenExpirationDate(expiration);
    }, []);

    const logout = useCallback(() => {
        setToken(null);
        setUserId(null);
        setTokenExpirationDate(null);
        localStorage.removeItem('userData');
    }, []);

    let routes;


    // http-hook
    const { sendRequest } = useHttpClient();

    // useEffect to fetch the data for the first time only without redenring
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('userData'));
        const fetchData = async () => {
            try {
                const expiration = new Date(userData.expiration);
                if(expiration < new Date()){
                    localStorage.removeItem('userData');
                    throw new Error('token expired');
                }
                const headers = { Authorization: 'Bearer ' + userData.token + ' ' + userData.userId };
                const response = await sendRequest(process.env.REACT_APP_BACKEND_URL + '/auth/check',
                    'GET', null, headers);
                setToken(response.user.token);
                setUserId(response.user.userId);
            } catch (err) {
                setToken(null);
                setUserId(null);
            };
        };
        fetchData();

    }, [sendRequest]);


    // For check expired token 
    useEffect(() => {
        if(token && tokenExpirationDate){
            const remainingTime = tokenExpirationDate.getTime() - new Date().getTime();
            logoutTimer = setTimeout(logout, remainingTime);
        } else {
            clearTimeout(logoutTimer);
        }
    }, [token, logout, tokenExpirationDate]);


    if (token) {
        console.log('there is token ' + token);
        routes = (
            <Routes>
                <Route path='/*' element={<InfoManagerView
                    infoData={props.infoData} updateInfodata={updateInfodata} />} />
                <Route path='/info' element={<InfoManagerView
                    infoData={props.infoData} updateInfodata={updateInfodata} />} />
                <Route path='/image'
                    element={<BackgroundImageManagerView infoData={props.infoData}
                        updateInfodata={updateInfodata} />} />
                <Route path='/category' element={<CategoryManagerView />} />
                <Route path='/product' element={<ProductManagerView />} />
            </Routes>
        )
    } else {
        console.log('there is no token ' + token);
        routes = (
            <Routes>
                <Route path='/*' element={<LoginView />} />
                <Route path='/login' element={<LoginView />} />
                <Route path='/login-failure' element={<LoginFailureView />} />
                <Route path='/login-success/:userId/:token' element={<LoginSuccessView />} />
            </Routes>
        )
    }

    // Update the main page when info is update
    function updateInfodata(newInfodata) {
        props.updateInfodata(newInfodata);
    }
    return (
        <AuthContext.Provider
            value={{
                isLoggedIn: !!token,
                token: token,
                userId: userId,
                tokenExpirationDate: tokenExpirationDate,
                login: login,
                logout: logout
            }} >
            <ManagerNavBar />
            {routes}
        </AuthContext.Provider>

    );
}

export default ManagerView;